<template>
  <div
    id="wrapper"
    @click="handleClick($event)"
    :class="{ isTopic, isExpand, tagNotChoosed, tagChoosed, isPointer, canDelete, common: true }"
  >
    {{ tagContent }}<i class="el-icon-close" v-if="canDelete" @click.stop="handleDelete($event)"></i>
  </div>
</template>

<script>
/**
 * 视频标签 & 视频话题
 * @ 使用场景：内容管理页标签(话题)展示, 内容详情页标签(话题)展示, 视屏上传页标签(话题)
 * @ 参数说明
 *
 * tagContent: 标签或者话题的内容
 *
 * isTopic: 是否为话题(字体为蓝色)
 *
 * isExpand: 是否为展开收起  explain: 上传视频页中当标签数目达到一定数量时 显示"展开" 或者"收起"
 *
 * tagChoosed: 是否为被选中tag  explain: 上传视频页中选择话题或者标签后, 显示被选中状态
 *
 * tagNotChoosed: 是否为未被选中tag  explain: 上传视频页中选择话题或者标签后, 未被选中的标签或话题(灰色框 白色背景)
 *
 * isPointer: 游标是否为小手
 *
 * canDelete: 是否为被确定的tag  explain: 上传视频页中，选择标签或话题后出入在选择框内的样式 并带有删除按钮(绿底白字 可删除)
 *
 *  */
export default {
  methods: {
    handleDelete($env) {
      this.$emit('delete', $env)
    },
    handleClick($env) {
      this.$emit('click', $env)
    },
  },
  props: {
    tagContent: {
      type: String,
      required: true,
    },
    isTopic: {
      type: Boolean,
      default: false,
    },
    isExpand: {
      type: Boolean,
      default: false,
    },
    tagNotChoosed: {
      type: Boolean,
      default: false,
    },
    tagChoosed: {
      type: Boolean,
      default: false,
    },
    isPointer: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.common {
  box-sizing: border-box;
  height: 22px;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 13px;
  line-height: 18px;
  margin: 2px 8px 2px 0;
  font-family: 'Microsoft YaHei';
  text-align: center;
  color: #666666;
  background: #f0f0f0;
}
.isTopic {
  background: rgba(111, 147, 189, 0.1);
  color: #6f93bd;
}
.isExpand {
  /* background: rgba(34, 66, 49, 0.1); */
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #1cdd74;
  color: #1cdd74;
  line-height: 16px;
  cursor: pointer;
}
.tagNotChoosed {
  background: rgba(255, 255, 255, 0.7);
  /* border: 1px solid #000; */
  color: #666666;
  line-height: 16px;
  cursor: pointer;
}
.tagChoosed {
  /* background: #ebebeb; */
  /* border:1px solid black; */
  /* color: #666666; */
  background: #22d26f;
  /* background: rgba(255, 255, 255, 0.7); */
  /* border: 1px solid #22d26f; */
  color: #fff;
  font-size: 13px;
  line-height: 16px;
  cursor: pointer;
}
.isPointer {
  cursor: pointer;
}
.canDelete {
  height: 26px;
  padding: 4px 9px;
  font-size: 12px;
  color: #ffffff;
  background: #22d26f;
}
.el-icon-close {
  margin-left: 2px;
  font-size: 14px;
  cursor: pointer;
}
</style>
